export const CREW_TEXT =
  "hey are you voting early? i heard it's a super big deal, i'm gonna do it. these folks put together all info on how/where/when if you need it ✊🏿✊🏾✊🏽✊🏼✊🏻"
export const POWER_TEXT =
  "hey are you voting early? i heard it's a super big deal, i'm gonna do it. these folks put together all info on how/where/when if you need it ✊🏿✊🏾✊🏽✊🏼✊🏻"
